module.exports = __webpack_public_path__ + "assets/icon_checklist.a50b57b8.svg";